import { motion } from "framer-motion";

// Line-by-line masked reveal
export const RevealLine = ({ children, delay = 0, className = "" }) => (
  <span className={`masked-line ${className}`}>
    <motion.span
      style={{ display: "block", willChange: "transform" }}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.1, ease: [0.7, 0, 0.15, 1], delay }}
    >
      {children}
    </motion.span>
  </span>
);

// In-view fade-up
export const FadeUp = ({ children, delay = 0, y = 32, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.9, ease: [0.22, 0.61, 0.36, 1], delay }}
  >
    {children}
  </motion.div>
);

// Scroll-driven mask reveal for a block of text (line-by-line)
export const RevealLinesOnView = ({ lines = [], className = "", baseDelay = 0 }) => (
  <>
    {lines.map((ln, i) => (
      <span className={`masked-line ${className}`} key={i}>
        <motion.span
          style={{ display: "block", willChange: "transform" }}
          initial={{ y: "110%" }}
          whileInView={{ y: "0%" }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{
            duration: 1.05,
            ease: [0.7, 0, 0.15, 1],
            delay: baseDelay + i * 0.09,
          }}
        >
          {ln}
        </motion.span>
      </span>
    ))}
  </>
);
